import { Link } from "wouter";
import { DOMAIN, PRODUCT_NAME } from "@shared/brand";

export function Footer() {
  return (
    <footer className="border-t border-[#E8DFCC] py-4 px-6 shrink-0">
      <div
        className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-[#65635C]"
        style={{ fontFamily: "var(--font-sans)" }}
      >
        <span>© 2026 {PRODUCT_NAME} Inc.</span>
        <Link href="/" className="hover:underline">Home</Link>
        <Link href="/privacy-policy" className="hover:underline">Privacy Policy</Link>
        <Link href="/terms-of-service" className="hover:underline">Terms of Service</Link>
        <a href={`mailto:support@${DOMAIN.primary}`} className="hover:underline">Contact</a>
      </div>
    </footer>
  );
}
